function getUnitDataLocalStorage() {
  try {
    return JSON.parse(
      localStorage.getItem("@UltragazEmpresarial:unitData") || ""
    );
  } catch (error) {
    return {
      unitId: null,
      instanceId: null,
      name: null,
      dueDay: null,
      deliveryType: null,
      hasGasMeter: null,
      hasCurrentHouseholder: true,
      address: []
    };
  }
}

const INITIAL_STATE = {
  unitsList: [],
  selectedUnit: getUnitDataLocalStorage()
};

const selectUnitReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;
  const reducer = {
    TOGGLE_SELECTED_UNIT: () => ({
      ...state,
      selectedUnit: action.unit
    }),
    UPDATE_SELECTED_UNIT: () => ({
      ...state,
      selectedUnit: { ...state.selectedUnit, ...action.object }
    }),
    SET_UNITS_LIST: () => ({ ...state, unitsList: action.units })
  };

  setLocalStorageInfo(action);

  return reducer[type] ? reducer[type]() : { ...state };
};

export default selectUnitReducer;

function setLocalStorageInfo(action) {
  if (action && action.unit && action.unit.address) {
    localStorage.setItem(
      "@UltragazEmpresarial:unitData",
      JSON.stringify(action.unit)
    );

    const address = action.unit.address.find(
      ad => ad.addressType === "SHIP_TO"
    );

    localStorage.setItem(
      "@UltragazEmpresarial:customerAddressLine",
      `${address.address || address.fullAddress}${
        address.number ? ", " + address.number : ""
      }${address.complement ? ", " + address.complement : ""}${
        address.neighborhood ? ", " + address.neighborhood : ""
      }${address.city ? ", " + address.city : ""}${
        address.stateCode ? "-" + address.stateCode : ""
      }${address.zipCode ? ", " + address.zipCode : ""}`
    );
  }
}
